import { gql } from "@apollo/client";
import { TRAVEL_UPSELL_DESTINATION_FIELDS, TRAVEL_UPSELL_FIELDS } from "./fragments";

export const CREATE_TRAVEL_UPSELL = gql`
  mutation CreateTravelUpsell($request: TravelUpsellRequestInput!) {
    createTravelUpsell(request: $request) {
      ${TRAVEL_UPSELL_FIELDS}
    }
  }
`;

export const UPDATE_TRAVEL_UPSELL = gql`
  mutation UpdateTravelUpsell($id: String!, $request: TravelUpsellRequestInput!) {
    updateTravelUpsell(id: $id, request: $request) {
      ${TRAVEL_UPSELL_FIELDS}
    }
  }
`;

export const SET_TRAVEL_UPSELL_ACTIVE = gql`
  mutation SetTravelUpsellActive($id: String!, $isActive: Boolean!) {
    setTravelUpsellActive(id: $id, isActive: $isActive) {
      id
      isActive
      updatedAt
    }
  }
`;

export const DELETE_TRAVEL_UPSELL = gql`
  mutation DeleteTravelUpsell($id: String!) {
    deleteTravelUpsell(id: $id)
  }
`;

export const SAVE_TRAVEL_UPSELL_DESTINATION = gql`
  mutation SaveTravelUpsellDestination($request: TravelUpsellDestinationRequestInput!) {
    saveTravelUpsellDestination(request: $request) {
      ${TRAVEL_UPSELL_DESTINATION_FIELDS}
    }
  }
`;

export const DELETE_TRAVEL_UPSELL_DESTINATION = gql`
  mutation DeleteTravelUpsellDestination($id: String!) {
    deleteTravelUpsellDestination(id: $id)
  }
`;
